import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  makeStyles,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { ReactNode } from 'react';

const useStyles = makeStyles((theme) => ({
  actions: {
    gap: 24,
    padding: '24px 40px',
  },
  closeButton: {
    padding: 1.5,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    padding: '24px 40px',
  },
  dialog: {
    borderRadius: 20,
  },
  paper: {
    backgroundColor:
      theme.palette.type === 'light'
        ? theme.palette.common.midTan
        : theme.palette.common.backgroundMuted,
    borderRadius: 20,
    color:
      theme.palette.type === 'light' ? theme.palette.common.midBlue : undefined,
  },
  title: {
    alignItems: 'center',
    borderBottom: `1px solid ${
      theme.palette.type === 'light'
        ? theme.palette.common.greyMid
        : theme.palette.common.backgroundNotification
    }`,
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px 40px',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(18),
  },
}));

type MaxWidth = false | 'md' | 'xs' | 'sm' | 'lg' | 'xl';

interface ModalProps {
  children: ReactNode;

  dataTestId?: string;

  footer?: ReactNode;

  hideClose?: boolean;

  maxWidth?: MaxWidth;

  open: boolean;

  title: string;

  closeHandler: () => void;
}

function Modal({
  children,
  closeHandler,
  dataTestId,
  footer,
  hideClose = false,
  maxWidth = 'md',
  open,
  title,
}: ModalProps) {
  const classes = useStyles();

  return (
    <Dialog
      fullWidth
      open={open}
      data-testid={dataTestId}
      classes={{
        root: classes.dialog,
        paper: classes.paper,
      }}
      maxWidth={maxWidth}
      onClose={closeHandler}
    >
      <DialogTitle disableTypography className={classes.title}>
        <Typography className={classes.titleText} variant="body1">
          {title}
        </Typography>

        {!hideClose && (
          <IconButton
            className={classes.closeButton}
            color="primary"
            aria-label="close"
            onClick={closeHandler}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent className={classes.content}>{children}</DialogContent>

      {footer && (
        <DialogActions className={classes.actions}>{footer}</DialogActions>
      )}
    </Dialog>
  );
}

export default Modal;
